// extracted by mini-css-extract-plugin
export default {"slotUnavailablePopup":"Style_slotUnavailablePopup__oHDFx","popHeader":"Style_popHeader__677J2","footer":"Style_footer__EpxMJ"};